import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastService } from 'app/toast/services/toast.service';
import { FacebookService } from 'app/facebook/providers/facebook';
import { UIParams } from 'app/facebook/models/ui-params';
import { UIResponse } from 'app/facebook/models/ui-response';

@Injectable({
  providedIn: 'root'
})
export class EventPageService {

  public themes = ['earth', 'minimal', 'tiffany', 'holidays', 'ocean', 'purple', 'positive-impact', 'empower', '', '', 'custom'];
  public selectedTheme = '';

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private fb: FacebookService,
    private toastService: ToastService,
  ) {
  }

  createCustomTheme(customTheme) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(customTheme))}`
    ];
    return this.http.post('/api/eventPage/customTheme/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateCustomTheme(customTheme) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(customTheme))}`
    ];
    return this.http.post('/api/eventPage/customTheme/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteCustomTheme(customThemeId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `eventId=${customThemeId}`
    ];
    return this.http.post('/api/eventPage/customTheme/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getCustomTheme(customThemeId) {
    const token = this.cookieService.get('accessToken');

    const queryParams = [
      `access_token=${token}`,
      `eventId=${customThemeId}`
    ];

    return this.http.post('/api/eventPage/customTheme/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getCustomThemesList() {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`
    ];

    return this.http.post('/api/eventPage/customTheme/get/all',  _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  onStopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  onClickTwitter(eventName = '', orgName = '' , date): void {
    const url = window.location.href;
    const formatDate = moment(new Date(date)).format('MMMM Do YYYY, h:mm a');

    const twitUrl = 'https://twitter.com/intent/tweet?text='
      + escape('Join me ' + formatDate + ' for ' + orgName + '\'s ' + eventName + '!')
      + '&url='
      + escape(url);

    window.open(twitUrl, '_blank');
  }

  onClickFB(eventName = '', orgName = '' , date): void {
    const formatDate = moment(new Date(date)).format('MMMM Do YYYY, h:mm a');
    const url = window.location.href;
    const options: UIParams = {
      method: 'share',
      href: url,
      quote: 'Join me ' + formatDate + ' for ' + orgName + '\'s ' + eventName + '!',
    };

    this.fb.ui(options)
      .then(
        (res: UIResponse) => console.log(res),
        (e: any) => {}
      );
  }

  onCopy(): string {
    return window.location.href;
  }

  onShowToaster() {
    this.toastService.show('success', 'Event Page Link Copied');
  }

  identify(index, item) {
    return item.id;
  }
}
